import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-partners',
    imports: [],
    templateUrl: './partners.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './partners.component.scss'
})
export class PartnersComponent {

}
